var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes profileViewerFadeIn{0%{opacity:0}to{opacity:1}}.profileViewer{background-color:#fff;animation-name:profileViewerFadeIn;animation-duration:.2s}.profileViewerName{height:24px;padding:0 6px 0 2px;border-right:1px solid var(--grey-30);line-height:24px;font-weight:700;color:var(--grey-60)}.profileViewerZipButton{width:18px;height:18px;margin:3px;padding:0;border:1px solid var(--green-60);background:var(--green-50) url(" + escape(require("../../../res/img/svg/back-arrow.svg")) + ") 50% no-repeat;flex:none;color:#000;border-radius:3px}.profileViewerZipButton:hover{border-color:#000}", ""]);

// exports
